import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '../Input';
import MagnifyingGlassIcon from '../../../icons/newIcons/MagnifyingGlassIcon';
export const SearchInput = ({ value, onClear, ...props }) => {
    return (_jsx(Input, { ...props, value: value, type: "search", prefix: _jsx(MagnifyingGlassIcon, { color: "currentColor", className: "size-5 text-neutral-400" }), clear: value.length > 0, onClear: onClear }));
};
